import React from 'react';
import {
  useStaticQuery, graphql, Link, navigate,
} from 'gatsby';
import useMediaQuery from '../util/useMediaQuery';
import { Accordion } from './Accordion';

const mq = useMediaQuery;

const CategoriesComponent = ({ categoryName }) => {
  const data = useStaticQuery(graphql`
    {
      allWordpressCategory {
        nodes {
          slug
          name
          count
        }
      }
    }
  `);
  const selectFunc = (e) => {
    const url = e.target[e.target.selectedIndex].getAttribute('data-value');
    navigate(url);
  };
  const categories = data.allWordpressCategory.nodes;
  const categoriesAvailable = categories.filter((val) => val.count > 0);
  return (
    <div className="categories-select">
      {mq('pc') ? (
        <Accordion Name={categoryName || 'すべてのトピック'} Title={categoryName || 'すべてのトピック'} Close="閉じる" CloseSimple>
          <div className="categories-list">
            <ul>
              <li>
                <Link to="/news/">すべてのトピック</Link>
              </li>
              {categoriesAvailable.map((category) => (
                <li key={category.slug}>
                  <Link to={`/news/${category.slug}/`}>{category.name}</Link>
                </li>
              ))}
            </ul>
          </div>
        </Accordion>
      ) : (
        <div className="sp-categories">
          <select
            name=""
            id=""
            value={categoryName}
            onChange={(e) => selectFunc(e)}
          >
            <option
              value="すべてのトピック"
              data-value="/news/"
            >
              すべてのトピック
            </option>
            {categoriesAvailable.map((category) => (
              <option
                value={category.name}
                defaultValue="すべてのトピック"
                data-value={`/news/${category.slug}/`}
                key={category.slug}
              >
                {category.name}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default CategoriesComponent;
